import { render } from "./requestWaitModal.vue?vue&type=template&id=bf32cbd0"
import script from "./requestWaitModal.vue?vue&type=script&lang=js"
export * from "./requestWaitModal.vue?vue&type=script&lang=js"

import "./requestWaitModal.vue?vue&type=style&index=0&id=bf32cbd0&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__